var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionSnapshotOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21a1.93 1.93 0 01-1.413-.587A1.928 1.928 0 013 19v-4h2v4h4v2H5zm10 0v-2h4v-4h2v4a1.93 1.93 0 01-.587 1.413A1.928 1.928 0 0119 21h-4zm-3-6a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 019 12c0-.833.292-1.542.875-2.125A2.893 2.893 0 0112 9c.833 0 1.542.292 2.125.875S15 11.167 15 12s-.292 1.542-.875 2.125A2.893 2.893 0 0112 15zM3 9V5c0-.55.196-1.021.587-1.413A1.928 1.928 0 015 3h4v2H5v4H3zm16 0V5h-4V3h4c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v4h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSnapshotOutline);
export default __webpack_public_path__ + "711cea602b11afd3fc9eca58503df0c5.svg";
export { ForwardRef as ReactComponent };